import {IconTrash} from '@tabler/icons-react';
import {Button} from 'src/design/atoms/Button';
import type {ButtonProps} from 'src/design/atoms/Button';

/**
 * "Delete" button — thin `Button` wrapper with a trash icon, `color="red"`,
 * defaulting its label to "Delete".
 * @registry Destructive "delete" action button.
 *
 * Ported from `library-m/components/buttons/DeleteButton`. Prop surface
 * kept identical (all `Button` props pass through, `children` defaults to
 * "Delete" but can still be overridden).
 */
export type DeleteButtonProps = ButtonProps;

export const DeleteButton = ({
  color = 'red',
  leftSection = <IconTrash />,
  children = 'Delete',
  ...props
}: DeleteButtonProps) => (
  <Button color={color} leftSection={leftSection} {...props}>
    {children}
  </Button>
);
